import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { GuestService } from '../../services/guest.service';

@Component({
  selector: 'app-hello',
  templateUrl: './hello.component.html',
  styleUrls: ['./hello.component.scss'],
})
export class HelloComponent {
  //
  constructor(public gs: GuestService) {}
}



// WEBPACK FOOTER //
// ./src/app/components/hello/hello.component.ts